<template>
    <div v-if="costData" class="panel-wrapper">
        <div class="content-row shadow-box">
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasUnitData">
                        <StackChart
                            ref="unitStackChart"
                            :title="'용도별 원단위 구성'"
                            :subTitle="`(${costData.values.unit.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                            :chartHeight="16"
                            :data="costData.values.unit.chartData"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                        <div style="margin-top: 10px">
                            <CompTable :tableData="usageTabledata" :timeDsvn="timeDsvn" />
                        </div>
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'용도별 원단위 구성'"
                            :subTitle="`(${costData.values.unit.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasElecData">
                        <BarChart
                            ref="elecBarChart"
                            :title="'전기 사용량 원단위'"
                            :subTitle="`(${costData.values.src.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                            :chartHeight="16"
                            :data="elecData.chart"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                        <div style="margin-top: 10px">
                            <CompTable :tableData="elecData.table" :timeDsvn="timeDsvn" />
                        </div>
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'전기 사용량 원단위'"
                            :subTitle="`(${costData.values.src.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasGasData">
                        <BarChart
                            ref="gasBarChart"
                            :title="'가스 사용량 원단위'"
                            :subTitle="`(${costData.values.src.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                            :chartHeight="16"
                            :data="gasData.chart"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                        <div style="margin-top: 10px">
                            <CompTable :tableData="gasData.table" :timeDsvn="timeDsvn" />
                        </div>
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'가스 사용량 원단위'"
                            :subTitle="`(${costData.values.src.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasHeatData">
                        <BarChart
                            ref="heatBarChart"
                            :title="'열 사용량 원단위'"
                            :subTitle="`(${costData.values.src.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                            :chartHeight="16"
                            :data="heatData.chart"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                        <div style="margin-top: 10px">
                            <CompTable :tableData="heatData.table" :timeDsvn="timeDsvn" />
                        </div>
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'열 사용량 원단위'"
                            :subTitle="`(${costData.values.src.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-row shadow-box">
            <div class="col-3">
                <!-- <h5>{{ "EnergySource section4" }}</h5> -->
                <energy-overview-panel :data="overviewData"></energy-overview-panel>
            </div>
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasRenData">
                        <StackChart
                            ref="chargeStackChart"
                            :title="'용도별 에너지 비용 구성'"
                            :subTitle="`(${costData.values.ren.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                            :chartHeight="24"
                            :data="costData.values.ren.chartData"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'용도별 에너지 비용 구성'"
                            :subTitle="`(${costData.values.ren.unit ?? '-'} · ${timeDsvn == 'YEAR' ? '년' : '월'})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <CostAnalysisTable :costDableData="costDableData" :timeDsvn="timeDsvn" />
            </div>
        </div>
    </div>
</template>

<script>
import BarChart from "../charts/BarChart";
import StackChart from "../charts/StackChart";
import CompTable from "../tables/CompTable";
import CostAnalysisTable from "../tables/CostAnalysisTable";
import analyzeConfig from "../analyzeConfig.json";
import EnergyOverviewPanel from "./EnergyOverviewPanel.vue";
import { isEmptyChartAndTableData, isEmptyChartData } from "@/utils/dataValidation";
import CommonTitlePanel from "./CommonTitlePanel.vue";

export default {
    props: {
        costData: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        BarChart,
        StackChart,
        CompTable,
        CostAnalysisTable,
        EnergyOverviewPanel,
        CommonTitlePanel,
    },
    data() {
        return {
            analyzeConfig: null,
            overviewData: null,
            xAxisLabelMonth: ["전월", "당월", "전년동월"],
            xAxisLabelYear: ["작년", "올해", "재작년"],
        };
    },
    computed: {
        timeDsvn() {
            return this.costData.headers[0].timeDsvn ?? "";
        },
        xAxisLabel() {
            const label = this.timeDsvn == "YEAR" ? ["작년", "올해", "재작년"] : ["전월", "당월", "전년동월"];
            return label ?? [];
        },
        elecData() {
            const data = {
                chart: null,
                table: null,
            };
            const chartArray = this.costData.values.src.chartData["전기"];
            const tableObj = this.costData.values.src.tableData["전기"];

            // chart 배열이 모두 0이거나 null이 아니면 chart 설정
            if (chartArray && !chartArray.every((value) => value == null || value === 0)) {
                data.chart = {
                    전기: chartArray,
                };
            }

            // table 객체가 모두 0이거나 null이 아니면 table 설정
            if (
                tableObj &&
                typeof tableObj === "object" &&
                !Object.values(tableObj).every((value) => value == null || value === 0)
            ) {
                data.table = tableObj;
            }

            return data;
        },
        usageTabledata() {
            const tableData = this.costData?.values?.unit?.tableData;
            if (!tableData) return;

            const result = Object.values(tableData).reduce((sums, row) => {
                for (const [key, value] of Object.entries(row)) {
                    sums[key] = (sums[key] || 0) + (value || 0);
                }
                return sums;
            }, {});

            // 모든 값이 0이거나 null이면 null 반환
            const allValuesEmpty = Object.values(result).every((value) => value == null || value === 0);
            return allValuesEmpty ? null : result;
        },
        gasData() {
            const data = {
                chart: null,
                table: null,
            };
            const chartArray = this.costData.values.src.chartData["가스"];
            const tableObj = this.costData.values.src.tableData["가스"];

            // chart 배열이 모두 0이거나 null이 아니면 chart 설정
            if (chartArray && !chartArray.every((value) => value == null || value === 0)) {
                data.chart = {
                    가스: chartArray,
                };
            }

            // table 객체가 모두 0이거나 null이 아니면 table 설정
            if (
                tableObj &&
                typeof tableObj === "object" &&
                !Object.values(tableObj).every((value) => value == null || value === 0)
            ) {
                data.table = tableObj;
            }

            return data;
        },
        heatData() {
            const data = {
                chart: null,
                table: null,
            };
            const chartArray = this.costData.values.src.chartData["지열"];
            const tableObj = this.costData.values.src.tableData["지열"];

            // chart 배열이 모두 0이거나 null이 아니면 chart 설정
            if (chartArray && !chartArray.every((value) => value == null || value === 0)) {
                data.chart = {
                    지열: chartArray,
                };
            }

            // table 객체가 모두 0이거나 null이 아니면 table 설정
            if (
                tableObj &&
                typeof tableObj === "object" &&
                !Object.values(tableObj).every((value) => value == null || value === 0)
            ) {
                data.table = tableObj;
            }

            return data;
        },
        costDableData() {
            const filterData = {
                usageData: {},
                energySourceData: {},
            };
            Object.keys(this.costData.values.trd.tableData).forEach((key) => {
                if (this.analyzeConfig.usageKey.includes(key)) {
                    filterData.usageData[key] = this.costData.values.trd.tableData[key];
                } else {
                    filterData.energySourceData[key] = this.costData.values.trd.tableData[key];
                }
            });
            return filterData;
        },
        hasUnitData() {
            if (!this.costData?.values?.unit) return false;
            return !isEmptyChartAndTableData(
                {
                    chartData: this.costData.values.unit.chartData,
                    tableData: this.usageTabledata, // computed로 변환된 tableData 사용
                },
                this.timeDsvn
            );
        },
        hasElecData() {
            if (!this.elecData?.chart || !this.elecData?.table) return false;
            return !isEmptyChartAndTableData(
                {
                    chartData: this.elecData.chart,
                    tableData: this.elecData.table,
                },
                this.timeDsvn
            );
        },
        hasGasData() {
            if (!this.gasData?.chart || !this.gasData?.table) return false;
            return !isEmptyChartAndTableData(
                {
                    chartData: this.gasData.chart,
                    tableData: this.gasData.table,
                },
                this.timeDsvn
            );
        },
        hasHeatData() {
            if (!this.heatData?.chart || !this.heatData?.table) return false;
            console.log("this.heatData.table", this.heatData.table);
            return !isEmptyChartAndTableData(
                {
                    chartData: this.heatData.chart,
                    tableData: this.heatData.table,
                },
                this.timeDsvn
            );
        },
        hasRenData() {
            if (!this.costData?.values?.ren?.chartData) return false;
            // ren은 tableData가 없으므로 chartData만 체크
            return !isEmptyChartData(this.costData.values.ren.chartData);
        },
    },
    watch: {
        costData: {
            deep: true,
            immediate: true,
            handler() {
                this.overviewData = this.readyOverviewData();
            },
        },
    },
    mounted() {},
    created() {
        this.analyzeConfig = analyzeConfig;
    },
    destroyed() {
        // console.log(`[DESTROYED] EnergySourceAnalysisPanel`);
    },
    methods: {
        readyOverviewData() {
            if (!this.costData) return;
            const timeDsvn = this.timeDsvn;

            function toThousands(value) {
                // value가 숫자이면 1000으로 나누어 반환 (toLocaleString()을 이용해 천단위 구분 기호 추가)
                return typeof value === "number" && !isNaN(value) ? value / 1000 : 0;
            }

            // costData의 값들을 Number로 변환 후 천원 단위로 변환
            const costBenefit = toThousands(Number(this.costData.values.over.genBenefit[1]) ?? 0);
            const currCost = toThousands(Number(this.costData.values.over.elecCost[1]) ?? 0);
            const accCost = toThousands(Number(this.costData.values.over.ytdCost) ?? 0);

            const prevMonth = toThousands(Number(this.costData.values.over.elecCost[0]) ?? 0);
            const prevYear = toThousands(Number(this.costData.values.over.elecCost[2]) ?? 0);

            // 차이 계산 시에는 원래 숫자 값 대신 천원 단위의 값 사용
            const prevRate = prevMonth ? (((currCost - prevMonth) / prevMonth) * 100).toFixed(2) : 0;
            const prevYearRate = prevYear ? (((currCost - prevYear) / prevYear) * 100).toFixed(2) : 0;

            const maxValue = Math.max(currCost, prevMonth, prevYear);

            return {
                title: "에너지 비용 개요",
                color: "#448AFF",
                table: [
                    { "발전 비용편익": [Number(costBenefit.toFixed(0)), "천원"] },
                    { 비용: [Number(currCost.toFixed(0)), "천원"] },
                    { "당해년도 누적 비용": [Number(accCost.toFixed(0)), "천원"] },
                ],
                chart: {
                    max: maxValue,
                    prevLeft: {
                        per: prevRate,
                        value: [Number(prevMonth.toFixed(0)), "천원"],
                    },
                    now: { value: [Number(currCost.toFixed(0)), "천원"] },
                    prevRight: { per: prevYearRate, value: [Number(prevYear.toFixed(0)), "천원"] },
                },
                timeDsvn,
            };
        },

        resizeChart() {
            this.$nextTick(() => {
                if (this.$refs.unitStackChart) this.$refs.unitStackChart.resizeChart();
                if (this.$refs.elecBarChart) this.$refs.elecBarChart.resizeChart();
                if (this.$refs.gasBarChart) this.$refs.gasBarChart.resizeChart();
                if (this.$refs.heatBarChart) this.$refs.heatBarChart.resizeChart();
                if (this.$refs.chargeStackChart) this.$refs.chargeStackChart.resizeChart();
            });
        },
    },
};
</script>

<style scoped>
.stack-table-container {
    width: 100%;
    height: 100%;
    /* display: flex;
    justify-content: space-between;
    flex-direction: column; */
}
.panel-wrapper {
    width: 100%;
    height: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px; /* row 간격 */
}

.content-row {
    display: flex;
    width: 100%;
    height: calc(50% - 5px); /* 두 영역 사이 gap 을 감안한 정확한 50% 분할 */
    padding: 10px;
    box-sizing: border-box;
    background-color: white;
    border-radius: 10px;
}

.shadow-box {
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
}

.empty-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #999;
}

.placeholder-icon {
    font-size: 2rem;
    color: #ccc;
}

.placeholder-text {
    font-size: 0.9rem;
    color: #666;
}
.placeholder-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #999;
}
.placeholder-icon {
    font-size: 2rem;
    color: #ccc;
}
.placeholder-text {
    font-size: 0.9rem;
    color: #666;
}
</style>
